import { get } from 'lodash'
import { useEffect } from 'react'

import routes from '../../../../constants/routes/routes'
import LoadingPage from '../../../common/LoadingPage'

const InitialLoading = ({ urlParams = {}, history }) => {
  useEffect(() => {
    const orgId = get(urlParams, 'routeParams.orgId') || get(urlParams, 'orgId')
    const formId = get(urlParams, 'routeParams.formId') || get(urlParams, 'formId')
    history.push({
      pathname: routes.registrationForm.path,
      search: `?orgId=${orgId}&formId=${formId}`,
    })
  }, [])
  return <LoadingPage label="Fetching Form" />
}

export default InitialLoading
